import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useKenhSuKien } from '../../hooks/useKenhSuKien';
import { useAuthStore } from '../../stores/auth';
import { NguCanhGate } from './NguCanhGate';

/**
 * Cổng chuyển hướng theo trạng thái đăng nhập.
 *
 * Bản gốc làm việc này bằng `middleware.ts` của Next.js, đọc một cookie
 * `foxai_auth` **chỉ xét có hay không**: không giải mã token nào. Đó là gợi ý
 * điều hướng, **không phải** kiểm tra phân quyền — phân quyền thật là header
 * `Authorization: Bearer` do API gateway xác thực (§3.6).
 *
 * Ở Vite không có middleware phía máy chủ, nên ta làm cùng việc đó bằng một
 * route wrapper: cùng hành vi `?redirect=<đường dẫn>`, cùng danh sách đường dẫn
 * công khai. Xem ADR-UI-0003.
 */
export function AuthGate() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  // Kênh sự kiện mở một lần cho cả khung đã đăng nhập, song song với lúc
  // `NguCanhGate` tải ngữ cảnh; đăng xuất thì hook tự đóng kênh.
  useKenhSuKien();

  if (!user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/dang-nhap?redirect=${redirect}`} replace />;
  }

  // Quyền và gói của tài khoản cổng tenant phải có trước khi vẽ khung (ADR-0034).
  return (
    <NguCanhGate>
      <Outlet />
    </NguCanhGate>
  );
}

/** Đã đăng nhập thì `/dang-nhap` và `/quen-mat-khau` đẩy về trang chủ (§3.6). */
export function GuestOnlyGate() {
  const user = useAuthStore((s) => s.user);
  if (user) return <Navigate to="/" replace />;
  return <Outlet />;
}
